import React from 'react'

function Button() {
  return (
    <>
        <button className='text-[#8c8c8c] text-[10px] font-semibold leading-[22px] border border-[#E5E5E5] dark:border-[#303036] dark:bg-[#24242B] rounded-[7px] px-2.5 py-0.5 inline-block'>View All</button>
    </>
  )
}

export default Button